const SUPPORT_EMAIL = 'support@futureproof.app';
const TERMS_OF_USE_LINK = 'https://futureproof.app/terms-of-use.html';
const PRIVACY_POLICY_LINK = 'https://futureproof.app/privacy-policy.html';
const COOKIE_POLICY_LINK = 'https://futureproof.app/cookie-policy.html';
const MONEY_BACK_POLICY_LINK = 'https://futureproof.app/terms-of-use.html#money-back-guarantee';
const SUBSCRIPTION_FEES_LINK = 'https://futureproof.app/terms-of-use.html#subscription-fees-and-payment';

export {
    SUPPORT_EMAIL,
    TERMS_OF_USE_LINK,
    PRIVACY_POLICY_LINK,
    COOKIE_POLICY_LINK,
    MONEY_BACK_POLICY_LINK,
    SUBSCRIPTION_FEES_LINK
};
